import { defineComponent as p, computed as r, provide as u, toRefs as a, nextTick as m } from "vue";
import { checkboxGroupProps as d, checkboxGroupContextKey as s } from "./checkbox-group.js";
const h = p({
  name: "ApCheckboxGroup",
  props: d,
  emits: ["update:modelValue", "change"],
  setup(t, { emit: n }) {
    const o = (e) => {
      n("update:modelValue", e), m(() => {
        n("change", e);
      });
    }, c = r({
      get() {
        return t.modelValue;
      },
      set(e) {
        o(e);
      }
    });
    return u(s, {
      ...a(t),
      modelValue: c,
      changeEvent: o
    }), {
      changeEvent: o,
      modelValue: c
    };
  }
});
export {
  h as default
};
